import { IItem, ISubMenuItems } from "../types/common.interface";

const TOP_MENU_ROLE_ADMIN: ISubMenuItems[] = [
  { value: "شهرداری", pathname: "/panel/administrator/municipality" },
  { value: "شرکت", pathname: "/panel/administrator/company" },
  { value: "راننده", pathname: "/panel/administrator/drivers" },
  { value: "مشتری ", pathname: "/panel/administrator/clients" },
  { value: "سفارش", pathname: "/panel/administrator/orders" },
  { value: "دسته بندی", pathname: "/panel/administrator/categories" },
  { value: "تیکت", pathname: "/panel/administrator/ticket" },
  // { value: "سایر", pathname: "/panel/administrator/other" },
];

const TOP_MENU_ROLE_COMPANY: ISubMenuItems[] = [
  { value: "راننده", pathname: "/panel/company/drivers" },
  // { value: "مشتری ", pathname: "/panel/company/clients" },
  { value: "سفارش", pathname: "/panel/company/orders" },
  // { value: "دسته بندی", pathname: "/panel/company/categories" },
  { value: "ویرایش قیمت", pathname: "/panel/company/update-price" },
  { value: "مناطق", pathname: "/panel/company/area" },
  { value: "ساعت کاری", pathname: "/panel/company/work-time" },
  { value: "تیکت", pathname: "/panel/company/ticket" },
];
const TOP_MENU_ROLE_Municipality: ISubMenuItems[] = [
  { value: "شرکت", pathname: "/panel/municipality/company" },
  { value: "راننده", pathname: "/panel/municipality/drivers" },
  { value: "مشتری ", pathname: "/panel/municipality/clients" },
  { value: "سفارش", pathname: "/panel/municipality/orders" },
  { value: "تیکت", pathname: "/panel/municipality/ticket" },
];

const LOGIN_ROLE_ITEM: IItem[] = [
  { name: "شهرداری", value: "MUNICIPALITY" },
  { name: "شرکت", value: "COMPANY" },
];

const topMenuItems = {
  TOP_MENU_ROLE_Municipality,
  TOP_MENU_ROLE_COMPANY,
  TOP_MENU_ROLE_ADMIN,
  LOGIN_ROLE_ITEM,
};

export default topMenuItems;
